export const EMPTY_CAR_NUMBER = "---------";

export const isEmptyCarNumber = (value) => {
  const normalized = String(value || "").trim();
  return !normalized || normalized === EMPTY_CAR_NUMBER;
};

export const getCarNumberFieldValue = (value) => {
  const normalized = String(value || "").trim();
  return isEmptyCarNumber(normalized) ? EMPTY_CAR_NUMBER : normalized;
};

export const getCarNumberSaveValue = (value) =>
  isEmptyCarNumber(value) ? "" : String(value).trim();
